/**
 * AddNodeMenu — floating "+" button listing the 8 card types. New cards
 * land at the current viewport center (via react-flow's
 * screenToFlowPosition) so they're never created off-screen.
 */

import React from 'react';
import { Plus } from 'lucide-react';
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem,
} from '@/components/ui/dropdown-menu';
import { NODE_TYPES } from './constants';

export default function AddNodeMenu({ onAdd }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          aria-label="Add card"
          className="flex items-center gap-1.5 rounded-full bg-coral-fill px-4 py-2.5 text-sm font-semibold text-[#FFF7F0] shadow-lift transition-transform hover:-translate-y-0.5"
        >
          <Plus className="h-4 w-4" /> Add Card
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-52 rounded-xl border-line bg-card text-ink">
        {NODE_TYPES.map(({ type, label, emoji }) => (
          <DropdownMenuItem key={type} onClick={() => onAdd(type)} className="gap-2">
            <span className="text-base leading-none">{emoji}</span> {label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
